<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-02-07 11:12:27
 * @FilePath: /wemeet-admin-new/src/views/marketing/phoneDelivery.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="手机号">
            <el-input v-model.trim="queryForm.phone" clearable placeholder="请输入手机号" />
          </el-form-item>

          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="姓名" prop="name" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.name ? row.name : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone" show-overflow-tooltip />
      <el-table-column label="公司/机构" prop="companyName" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.companyName ? row.companyName : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="职位" prop="position" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.position ? row.position : '/' }}
        </template>
      </el-table-column>

      <el-table-column label="入池时间" prop="createTime" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.createTime ? row.createTime : '/' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" show-overflow-tooltip width="420">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleSend(row)">投放</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="请输入手机号，查询用户后再投放" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNumber"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <sendMessageVue ref="sendMessageRef" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { useRoute } from 'vue-router'
  import { getEnterpriseMarketingQueryEnterpriseUserDetail } from '@/api/exhibitionManage'
  import VisitorImport from './components/visitorImport.vue'
  import sendMessageVue from './components/sendMessage.vue'
  import { getUserByPhone } from '@/api/user'
  export default defineComponent({
    name: 'Brand',
    components: {
      addGroup: defineAsyncComponent(() => import('./components/addGroup')),
      VisitorImport,
      sendMessageVue,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          phone: '',
        },
        activeName: 'first',
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        addgroupDrawer: null,
        chooseVal: [],
        importRef: null,
        sendMessageRef: null,
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.exhibitorCode) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        if (!state.queryForm.phone) {
          proxy.$baseMessage(`手机号码不能为空`, 'error', 'vab-hey-message-error')
          return false
        }
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        try {
          const { data } = await getEnterpriseMarketingQueryEnterpriseUserDetail(state.queryForm)
          state.list = [data]
        } catch (e) {
          state.listLoading = false
          state.list = []
        }
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      onActivated(() => {
        // fetchData()
      })

      const addGroupFunc = () => {
        state.addgroupDrawer.handleOpen()
      }

      const handleSend = (row) => {
        row.phone = state.queryForm.phone
        row.userNum = 1
        state.sendMessageRef.handleOpen(row)
      }

      const handleSort = (row) => {
        state.editRef.showEdit(row)
      }
      const importBrand = () => {
        state.upLoadRef.showEdit()
      }
      const importProductBrand = () => {
        state.productUploadRef.showEdit()
      }
      const importResult = () => {
        state.resultRef.showEdit()
      }

      const handleShare = (row) => {
        state.previewWebSite = row.exhibitorH5Url
        state.previewQrcode = row.exhibitorQrcode
        state.previewDialog.handleOpen()
      }

      const importData = () => {
        state.importRef.showEdit()
      }

      return {
        ...toRefs(state),
        importData,
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        importProductBrand,
        handleConfig,
        Delete,
        Search,
        Plus,
        addGroupFunc,
        handleSort,
        handleSend,
        handleShare,
        importResult,
        importBrand,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
